import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { HistoryRouter } from 'redux-first-history/rr6';
import redux from 'reduxStore';
import { Toaster } from 'react-hot-toast';
import Layout from 'containers/Layout';
import * as serviceWorker from 'serviceWorker';
import './styles.css';
import './styles_override.css';
import './styles/promotion-modal.css';
import Router from 'Router';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={redux.store}>
    <PersistGate loading={null} persistor={redux.persistor}>
      <HistoryRouter history={redux.history}>
        <Layout>
          <Router />
        </Layout>
      </HistoryRouter>
    </PersistGate>
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 3000,
        style: {
          background: '#363636',
          color: '#fff',
        },
      }}
    />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
